import React, { useState } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  ListGroup,
  Form,
  Container,
} from "react-bootstrap";
import IMAGES from "../constants/images";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { BsHeart } from "react-icons/bs";
import PaginatedList from "./PaginatedList";
import { useAuth } from "context/UserContext";
import { toast } from "react-toastify";

const productsData = {
  "Project Management": [
    {
      name: "Cloudflare Application Security & Perform...",
      reviews: 2306,
      rating: 4.5,
      image: IMAGES.C_Logo1,
      bgColor: "#FEF5ED",
      description:
        "Cloudflare is the cloud for the “everywhere world”. At Cloudflare, we have our eyes set on an ambitious goalto help build a better Internet. Today, everything needs to be connected to e...",
    },
    {
      name: "Jscrambler",
      reviews: 4026,
      rating: 4.5,
      image: IMAGES.C_Logo2,
      bgColor: "#DFDFFF",
      description:
        "Jscrambler is the leader in Client-Side Protection and Compliance. We were the first to merge advanced polymorphic JavaScript obfuscation with fine-grained third-party tag protection...",
    },
    {
      name: "Reflectiz",
      reviews: 2536,
      rating: 4.5,
      image: IMAGES.C_Logo3,
      bgColor: "#DFDDFF",
      description:
        "Reflectiz keeps online businesses safe by mitigating security and privacy risks resulting from next generation third-party threats on your website, without adding a single line of code...",
    },
    {
      name: "Feroot",
      reviews: 3026,
      rating: 4.5,
      image: IMAGES.C_Logo4,
      bgColor: "#F3E5FF",
      description:
        "Feroot Security is a cutting-edge cybersecurity company headquartered in Toronto, Canada, with a mission to safeguard the client-side of websites and web applications. Founded...",
    },
    {
      name: "Imperva Client-Side Protection",
      reviews: 6524,
      rating: 4.5,
      image: IMAGES.C_Logo5,
      bgColor: "#EDEADC",
      description:
        "As businesses rely on increasingly complex websites powered by third-party JavaScript, they expose themselves to a new breed of cyber threats that target users directly in their browser...",
    },
    {
      name: "Otto",
      reviews: 6523,
      rating: 4.5,
      image: IMAGES.C_Logo6,
      bgColor: "#F0EAFF",
      description:
        "Otto-js defends your live WebApp against attacks at runtime while continuously monitoring for new risks, vulnerabilities, and out-of-compliant scripts. otto-js is an end-to-end script securi...",
    },
    {
      name: "Radware Client-Side Protection",
      reviews: 8452,
      rating: 4.5,
      image: IMAGES.C_Logo7,
      bgColor: "#F5F5F5",
      description:
        "Client-Side Protection ensures that end users are safeguarded from cyber threats originating within the application supply chain. It helps detect and prevent attacks such as malware inje...",
    },
    {
      name: "Source Defense Protect",
      reviews: 5620,
      rating: 4.5,
      image: IMAGES.C_Logo8,
      bgColor: "#D4FCE7",
      description:
        "Automated protection against all client-side threats, Source Defense Protect is a turnkey, automated web security and data privacy compliance solution designed to protect data a...",
    },
  ],
};

const RatingStars = ({ rating }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <span key={i} style={{ color: i <= rating ? "#FFC107" : "#ccc" }}>
        ★
      </span>
    );
  }
  return <span>{stars}</span>;
};

const ClientSideCategoriesComponent = () => {
  const navigate = useNavigate();
  const {  user,isLoggedIn } = useAuth();
  const [selectedCategory] = useState("Project Management");
  const products = productsData[selectedCategory];
  const [selectedProducts, setSelectedProducts] = useState([]);

  const handleSelect = (product) => {
    if (selectedProducts.includes(product)) {
      setSelectedProducts(selectedProducts.filter((p) => p !== product));
    } else if (selectedProducts.length < 2) {
      setSelectedProducts([...selectedProducts, product]);
    }
  };

  const handleRemove = (product) => {
    setSelectedProducts(selectedProducts.filter((p) => p !== product));
  };

  const handleClearAll = () => {
    setSelectedProducts([]);
  };

  return (
    <div>
      <Container>
        <Row className="categories_section categories_section1">
          {products.map((product, index) => (
            <Col lg={6} xl={6} md={12} sm={12} key={index} className="mb-2">
              <Card>
                <Card.Body>
                  <Form.Check
                    type="checkbox"
                    id={`compare-${index}`}
                    name="compare"
                    label="Compare Product"
                    className="comparepos"
                    checked={selectedProducts.includes(product)}
                    onChange={() => handleSelect(product)}
                  />
                  <Link
                    to="/solution-product-details"
                    className="iconBox"
                    style={{
                      backgroundColor: product.bgColor,
                    }}
                  >
                    <img
                      src={product.image}
                      alt={product.name}
                      style={{ width: 50, height: 50,objectFit:"contain" }}
                    />
                  </Link>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <Link
                        to="/solution-product-details"
                        className="text-decoration-none text-dark hoverAnchorColor"
                      >
                        <Card.Title className="mb-2">{product.name}</Card.Title>
                      </Link>
                      <Card.Text className="mb-0">
                        <RatingStars rating={product.rating} /> (
                        {product.reviews}) 4.7 <span>out of</span> 5
                      </Card.Text>
                    </div>
                  {(!user || user.role === "user") &&  <Button 
                    onClick={()=>{
                      if (!isLoggedIn) {
                        toast.error("Please login to write a review", {
                          toastId: "login-required"
                        });
                        return;
                      }
                      navigate("/write-a-review")
                      const updatedChecked = [product];

                      localStorage.setItem(
                        "checkedProducts",
                        JSON.stringify(updatedChecked)
                      );
                      localStorage.setItem("step", 2);
                    }}
                    variant="danger" size="sm" >
                      Write A Review
                    </Button>}
                  </div>
                  <Card.Title className="mb-2">Product Description</Card.Title>
                  <p className="para">
                    {product.description}
                    <Link className="seeMore">See More</Link>
                  </p>
                  <Card.Title className="mb-2 font14 fw-bold">
                    Other Info
                  </Card.Title>
                  <ListGroup className="customListGroup">
                    <ListGroup.Item>
                      <Icon icon="tabler:users" fontSize={24} />
                      <span>
                        <strong>Users</strong> (Project Manager, CEO)
                      </span>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Icon icon="clarity:building-line" fontSize={24} />
                      <span>
                        <strong>Industries</strong> (Marketing & Advertising, IT
                        and Services)
                      </span>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Icon icon="ph:line-segments" fontSize={24} />
                      <span>
                        <strong>Market Segment</strong> (63% Small-Business, 29%
                        Mid-Market)
                      </span>
                    </ListGroup.Item>
                  </ListGroup>

                  <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                    <Link className="d-flex align-items-center text-secondary fw-normal font14 text-decoration-none">
                      <BsHeart className="text-danger me-2" size={20} />
                      Save to My List
                    </Link>
                    <Button
                      variant="outline-danger"
                      className="ms-0 ms-md-auto px-3 border-radius-100"
                    >
                      Entry Level Price:{" "}
                      <span className="text-primary">$ Free</span>
                    </Button>
                    <Button variant="info" className="border-radius-100 px-4">
                      Try For Free
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
          <PaginatedList totalItems={30} itemsPerPage={10} />
        </Row>
      </Container>

      {/* Sticky Comparison Bar */}
      {selectedProducts.length > 0 && (
        <div className="sticky-bottom compareBar">
          <Button variant="outline-info" onClick={handleClearAll}>
            Remove All
          </Button>
          <div className="d-flex gap-3">
            {selectedProducts.map((product, index) => (
              <div
                key={index}
                className="position-relative proBox"
                style={{
                  backgroundColor: product.bgColor,
                }}
              >
                <div className="closeBtn">
                  <button
                    className="btn-close"
                    onClick={() => handleRemove(product)}
                  >
                    <Icon icon="basil:cross-solid" fontSize={20} />
                  </button>
                </div>
                <img
                  src={product.image}
                  alt={product.name}
                  style={{ width: 40, height: 40 }}
                />
              </div>
            ))}
          </div>
          {selectedProducts.length === 2 && (
            <Button
              variant="info"
              onClick={() => {
                navigate("/product-comparision");
              }}
            >
              Compare Now
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default ClientSideCategoriesComponent;
